import {
  AuthPrimary,
  BannerVariant,
  CargoTypes,
  EquipmentTypes,
  Status,
  TransportLoadCapacities,
  TransportSideTypes,
  TransportTypes,
} from '../types/enums'
import {
  BannerVariantConfigMap,
  CargoUnit,
  Instruction,
  ListParams,
  TypeSelectorItem,
  ValidationRulesInterface,
} from '../types/interfaces'
import { orderStatusToText } from './functions/enumToText'
import settings from '../../assets/images/screens/settings.webp'
import payment from '../../assets/images/screens/payment.webp'
import payment_method from '../../assets/images/screens/payment_method.webp'
import support from '../../assets/images/screens/support.webp'
import on_map_1 from '../../assets/images/screens/on_map_1.webp'
import on_map_2 from '../../assets/images/screens/on_map_2.webp'
import on_map_3 from '../../assets/images/screens/on_map_3.webp'
import filters from '../../assets/images/screens/filters.webp'
import sort from '../../assets/images/screens/sort.webp'
import navi from '../../assets/images/screens/navi.webp'
import navi_icons from '../../assets/images/screens/navi_icons.webp'
import orders from '../../assets/images/screens/orders.webp'
import orders_main from '../../assets/images/screens/orders_main.webp'
import orders_map from '../../assets/images/screens/orders_map.webp'
import create_order_1 from '../../assets/images/screens/create_order_1.webp'
import create_order_2 from '../../assets/images/screens/create_order_2.webp'
import create_order_3 from '../../assets/images/screens/create_order_3.webp'
import auth_1 from '../../assets/images/screens/auth_1.webp'
import auth_2 from '../../assets/images/screens/auth_2.webp'
import auth_3 from '../../assets/images/screens/auth_3.webp'
import types_1 from '../../assets/images/screens/types_1.webp'
import types_2 from '../../assets/images/screens/types_2.webp'
import types_3 from '../../assets/images/screens/types_3.webp'

export const COUNTRY = process.env.REACT_APP_COUNTRY || 'ru'

export const currencyConfig: Record<string, { symbol: string; rate: number; locale: string }> = {
  ru: { symbol: '₽', rate: 1, locale: 'ru-RU' },
  by: { symbol: 'BYN', rate: 30, locale: 'be-BY' },
  kz: { symbol: '₸', rate: 0.2, locale: 'kk-KZ' },
}

export const AUTH_TYPE: AuthPrimary = AuthPrimary.EMAIL
export const SHOULD_COLLECT_EMAIL = true

export const weekDaysEn = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN']
export const weekDaysRu = ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС']

export const SEARCH_DEBOUNCE_MS = 200

export const maxFieldTemplatesCount = 20

export const maxFieldNameLength = 50
export const maxFieldDescriptionLength = 200

export const maxFormPointsCount = 6
export const minRouteFormPointsCount = 2
export const minUploadFilesCount = 1
export const blurFocusTimeout = 200
export const chatAdminId = 1
export const copyDelay = 1000
export const autoMessageDelay = 30000
export const autoMessageStep = 1000
export const minContacts = 0
export const maxCargoUnits = 5
export const loaderDelay = 300
export const checkOrderDelay = 60000
export const maxClusterSettingsCount = 10

//cat attrs
export const sortStep = 100
export const maxAttributesCount = 10
export const maxOptionsLength = 20
export const maxOptionsTextFieldLength = 100
export const maxParamNameLength = 30
export const maxSelectOptionLength = 30
export const maxNumberValueLength = 8

export const MAIN_ROUTE = '/'
export const INFO_ROUTE = '/info'

export const russiaCenter = { lat: 66.25, lng: 94.15 }

const DOMAIN = COUNTRY === 'ru' ? 'ru' : COUNTRY

export const baseUrl = `https://logid.${DOMAIN}`
export const imageUrl = `https://logid.${DOMAIN}/api/v1/data/file?path=`

//user
export const USER_ROUTE = '/user'
export const LOGIN_ROUTE = '/login'
export const SLOT_ROUTE = '/slot'
export const SLOT_FORM_ROUTE = '/slot/form'
export const SLOT_MY_ROUTE = '/slot/my'
export const SLOT_SELECTED_ROUTE = '/slot/selected'
export const CARGO_ROUTE = '/cargo'
export const CARGO_FORM_ROUTE = '/cargo/form'
export const CARGO_MY_ROUTE = '/cargo/my'
export const CARGO_SELECTED_ROUTE = '/cargo/selected'
export const TRANSPORT_ROUTE = '/transport'
export const TRANSPORT_FORM_ROUTE = '/transport/form'
export const TRANSPORT_MY_ROUTE = '/transport/my'
export const TRANSPORT_SELECTED_ROUTE = '/transport/selected'
export const SETTINGS_ROUTE = '/settings'
export const DASHBOARD_ROUTE = '/dashboard'

export const CATEGORY_ROUTE = '/category'
export const SALE_ITEM_ROUTE = '/sale_item'
export const STORE_ROUTE = '/store'
export const ORDER_ROUTE = '/order'
export const COMPLEX_ORDER_ROUTE = '/complex_order'
export const CLUSTER_ROUTE = '/cluster'
export const PROMO_ROUTE = '/promo'
export const STOCK_ROUTE = '/stock'
export const PRICE_ROUTE = '/price'
export const PLACE_ROUTE = '/place'
export const CAT_UPLOAD_ROUTE = '/cat_upload'
export const EXECUTOR_ROUTE = '/executor'
export const DOCUMENT_ROUTE = '/document'
export const MOTIVATION_ROUTE = '/motivation'
export const TASK = '/task'
export const TASK_ITEM = '/task'


//items
export const CARGO_ITEM_ROUTE = '/cargo/item'
export const SLOT_ITEM_ROUTE = '/slot/item'
export const TRANSPORT_ITEM_ROUTE = '/transport/item'

//legality
export const USER_AGREEMENT_ROUTE = '/user_agreement'
export const PRIVACY_POLICY_ROUTE = '/privacy_policy'
export const PERSONAL_DATA_AGREEMENT_ROUTE = '/personal_data_agreement'

export const validPercent = /^([1-9]|[1-9][0-9]|100)$/
export const validName = /^/
export const validDescription = /^/
export const validNumber = /^[0-9]*$/
export const positiveNumber = /^[1-9][0-9]*$/
export const validCode = /^[0-9]{1,6}$/

// const ruPhoneRegex = /(^8|7|\+7)((\d{10})|(\s\(\d{3}\)\s\d{3}\s\d{2}\s\d{2}))/
// const byPhoneRegex = /^\+375\s?\d{2}\s?\d{3}\s?\d{2}\s?\d{2}$/
// const kzPhoneRegex = /^\+7\s?\d{3}\s?\d{3}\s?\d{2}\s?\d{2}$/
const ruPhoneRegex = /^\+?(7|8|375)\d{9,10}$/
const byPhoneRegex = /^\+?(7|8|375)\d{9,10}$/
const kzPhoneRegex = /^\+?(7|8|375)\d{9,10}$/

const phoneRegexByCountry: Record<string, RegExp> = {
  ru: ruPhoneRegex,
  by: byPhoneRegex,
  kz: kzPhoneRegex,
}

export const validPhone = phoneRegexByCountry[COUNTRY] || ruPhoneRegex

const ruEmailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+ru))$/
const anyEmailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const validEmail = COUNTRY === 'ru' ? ruEmailRegex : anyEmailRegex

export const euroPallet: CargoUnit = {
  weight: '',
  count: '',
  width: '80',
  height: '180',
  length: '120',
}
export const usaPallet: CargoUnit = {
  weight: '',
  count: '',
  width: '102',
  height: '180',
  length: '122',
}
export const finPallet: CargoUnit = {
  weight: '',
  count: '',
  width: '100',
  height: '180',
  length: '120',
}

export const slotValidations: ValidationRulesInterface[] = [
  {
    fieldName: 'name',
    minLength: 10,
    maxLength: 150,
    canBeEmpty: false,
    format: validName,
    isEmptyMessage: 'Название обязательно',
    toShortMessage: 'Напишите больше',
    tooLongMessage: 'Сократите название для большей информативности',
    formatMessage: 'Вы ввыели что-то не подходящее',
  },
  {
    fieldName: 'description',
    minLength: 30,
    maxLength: 500,
    canBeEmpty: false,
    format: validDescription,
    isEmptyMessage: 'Без описания слот не добавить',
    toShortMessage: 'Напишите подробнее',
    tooLongMessage: 'Сократите описание для большей информативности',
    formatMessage: 'Вы ввели что-то неподходящее',
  },
]
export const cargoValidations: ValidationRulesInterface[] = [
  {
    fieldName: 'name',
    minLength: 10,
    maxLength: 150,
    canBeEmpty: false,
    format: validName,
    isEmptyMessage: 'Название обязательно',
    toShortMessage: 'Напишите больше',
    tooLongMessage: 'Сократите название для большей информативности',
    formatMessage: 'Вы ввели что-то неподходящее',
  },
  {
    fieldName: 'description',
    minLength: 30,
    maxLength: 500,
    canBeEmpty: false,
    format: validDescription,
    isEmptyMessage: 'Без описания груз не добавить',
    toShortMessage: 'Напишите подробнее',
    tooLongMessage: 'Сократите описание для большей информативности',
    formatMessage: 'Вы ввели что-то неподходящее',
  },
]
export const transportValidations: ValidationRulesInterface[] = [
  {
    fieldName: 'name',
    minLength: 10,
    maxLength: 150,
    canBeEmpty: false,
    format: validName,
    isEmptyMessage: 'Название обязательно',
    toShortMessage: 'Напишите больше',
    tooLongMessage: 'Сократите название для большей информативности',
    formatMessage: 'Вы ввели что-то неподходящее',
  },
  {
    fieldName: 'description',
    minLength: 30,
    maxLength: 500,
    canBeEmpty: false,
    format: validDescription,
    isEmptyMessage: 'Без описания транспорт не добавить',
    toShortMessage: 'Напишите подробнее',
    tooLongMessage: 'Сократите описание для большей информативности',
    formatMessage: 'Вы ввели что-то неподходящее',
  },
]

export const loginValidations = [
  {
    fieldName: 'phone_number',
    minLength: 11,
    maxLength: 12,
    canBeEmpty: false,
    format: validPhone,
    isEmptyMessage: 'Введите телефон',
    toShortMessage: 'Телефон слишком короткий',
    tooLongMessage: 'Телефон слишком длинный',
    formatMessage: 'Телефон в неверном формате',
  },
  {
    fieldName: 'code',
    minLength: 6,
    maxLength: 6,
    canBeEmpty: false,
    format: validCode,
    isEmptyMessage: 'Введите код',
    toShortMessage: 'Код слишком короткий',
    tooLongMessage: 'Код слишком длинный',
    formatMessage: 'Код не верного формата',
  },
]

export const orderValidations = [
  {
    fieldName: 'storeId',
    canBeEmpty: false,
    minLength: 1,
    format: validNumber,
    isEmptyMessage: 'Выберите торговую точку',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
  {
    fieldName: 'phone_number',
    canBeEmpty: false,
    minLength: 5,
    maxLength: 12,
    format: validPhone,
    isEmptyMessage: 'Введите номер телефона',
    toShortMessage: 'Номер телефона слишком короткий',
    tooLongMessage: 'Номер телефона слишком длинный',
    formatMessage: 'Номер телефона не верного формата',
  },
  {
    fieldName: 'description',
    minLength: 0,
    maxLength: 200,
    canBeEmpty: true,
    format: validDescription,
    isEmptyMessage: 'Введите комментарии',
    toShortMessage: 'Комментарии слишком коротокие',
    tooLongMessage: 'Комментарии слишком длинные',
    formatMessage: 'Комментарии не верного формата',
  },
  {
    fieldName: 'notes',
    minLength: 0,
    maxLength: 200,
    canBeEmpty: true,
    format: validDescription,
    isEmptyMessage: 'Введите заметки',
    toShortMessage: 'Заметки слишком коротокие',
    tooLongMessage: 'Заметки слишком длинные',
    formatMessage: 'Заметки не верного формата',
  },
]
export const storeValidations = [
  {
    fieldName: 'name',
    minLength: 5,
    maxLength: 100,
    canBeEmpty: false,
    format: validName,
    isEmptyMessage: 'Введите название',
    toShortMessage: 'Название слишком короткое',
    tooLongMessage: 'Название слишком длинное',
    formatMessage: 'Название не верного формата',
  },
  {
    fieldName: 'sortOrder',
    minLength: 0,
    maxLength: 6,
    canBeEmpty: true,
    format: validNumber,
    isEmptyMessage: 'Введите число',
    toShortMessage: 'Значение слишком короткое',
    tooLongMessage: 'Значение слишком длинное',
    formatMessage: 'Значение не верного формата',
  },
  {
    fieldName: 'description',
    minLength: 30,
    maxLength: 1000,
    canBeEmpty: false,
    format: validDescription,
    isEmptyMessage: 'Введите описание',
    toShortMessage: 'Описание слишком коротокое',
    tooLongMessage: 'Описание слишком длинное',
    formatMessage: 'Описание не верного формата',
  },
  {
    fieldName: 'phone_number',
    canBeEmpty: false,
    minLength: 5,
    maxLength: 12,
    format: validPhone,
    isEmptyMessage: 'Введите номер телефона',
    toShortMessage: 'Номер телефона слишком короткий',
    tooLongMessage: 'Номер телефона слишком длинный',
    formatMessage: 'Номер телефона не верного формата',
  },
  {
    fieldName: 'deliveryRadius',
    canBeEmpty: false,
    minLength: 1,
    maxLength: 5,
    format: validNumber,
    isEmptyMessage: 'Введите радиус доставки',
    toShortMessage: 'Радиус доставки слишком короткий',
    tooLongMessage: 'Радиус доставки слишком длинный',
    formatMessage: 'Радиус доставки не верного формата',
  },
  // {
  //   fieldName: 'clusterId',
  //   canBeEmpty: false,
  //   minLength: 1,
  //   format: validNumber,
  //   isEmptyMessage: 'Выберите категорю',
  //   toShortMessage: '',
  //   tooLongMessage: '',
  //   formatMessage: '',
  // },
]
export const itemValidations = [
  {
    fieldName: 'name',
    minLength: 2,
    maxLength: 200,
    canBeEmpty: false,
    format: validName,
    isEmptyMessage: 'Введите название',
    toShortMessage: 'Название слишком короткое',
    tooLongMessage: 'Название слишком длинное',
    formatMessage: 'Название не верного формата',
  },
  {
    fieldName: 'description',
    minLength: 30,
    maxLength: 2500,
    canBeEmpty: false,
    format: validDescription,
    isEmptyMessage: 'Введите описание',
    toShortMessage: 'Описание слишком коротокое',
    tooLongMessage: 'Описание слишком длинное',
    formatMessage: 'Описание не верного формата',
  },
  {
    fieldName: 'categoryId',
    canBeEmpty: false,
    minLength: 1,
    format: validNumber,
    isEmptyMessage: 'Выберите категорю',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
  {
    fieldName: 'unit',
    canBeEmpty: false,
    minLength: 1,
    format: validNumber,
    isEmptyMessage: 'Выберите единицу измерения',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
  {
    fieldName: 'minQuantity',
    canBeEmpty: false,
    minLength: 1,
    maxLength: 6,
    format: positiveNumber,
    isEmptyMessage: 'Не меньше 1',
    toShortMessage: 'Не меньше 1',
    tooLongMessage: 'Не больше 999 999',
    formatMessage: 'Введите целое число не меньше 1',
  },
  {
    fieldName: 'quantityStep',
    canBeEmpty: false,
    minLength: 1,
    maxLength: 6,
    format: positiveNumber,
    isEmptyMessage: 'Не меньше 1',
    toShortMessage: 'Не меньше 1',
    tooLongMessage: 'Не больше 999 999',
    formatMessage: 'Введите целое число не меньше 1',
  },
]
export const stockValidations = [
  {
    fieldName: 'saleItemId',
    canBeEmpty: false,
    minLength: 1,
    format: validNumber,
    isEmptyMessage: 'Выберите товар',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
  {
    fieldName: 'storeId',
    canBeEmpty: false,
    minLength: 1,
    format: validNumber,
    isEmptyMessage: 'Выберите торговую точку',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
  {
    fieldName: 'count',
    canBeEmpty: false,
    minLength: 1,
    maxLength: 5,
    format: validNumber,
    isEmptyMessage: 'Введите количество',
    toShortMessage: 'Значение слишком короткое',
    tooLongMessage: 'Значение слишком длинное',
    formatMessage: 'Значение не верного формата',
  },
]
export const priceValidations = [
  {
    fieldName: 'saleItemId',
    canBeEmpty: false,
    minLength: 1,
    format: validNumber,
    isEmptyMessage: 'Выберите товар',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
  // {
  //   fieldName: 'storeId',
  //   canBeEmpty: false,
  //   minLength: 1,
  //   format: validNumber,
  //   isEmptyMessage: 'Выберите торговую точку',
  //   toShortMessage: '',
  //   tooLongMessage: '',
  //   formatMessage: '',
  // },
  {
    fieldName: 'price',
    canBeEmpty: false,
    minLength: 1,
    maxLength: 8,
    format: validNumber,
    isEmptyMessage: 'Введите цену',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
]

export const clusterValidations = [
  {
    fieldName: 'phone_number',
    canBeEmpty: false,
    minLength: 5,
    maxLength: 12,
    format: validPhone,
    isEmptyMessage: 'Введите номер телефона',
    toShortMessage: 'Номер телефона слишком короткий',
    tooLongMessage: 'Номер телефона слишком длинный',
    formatMessage: 'Номер телефона не верного формата',
  },
  {
    fieldName: 'type',
    canBeEmpty: false,
    minLength: 1,
    format: validNumber,
    isEmptyMessage: 'Выберите тип',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
  {
    fieldName: 'legalName',
    minLength: 3,
    maxLength: 255,
    canBeEmpty: false,
    format: validName,
    isEmptyMessage: 'Введите название организации',
    toShortMessage: 'Название слишком короткое',
    tooLongMessage: 'Название слишком длинное',
    formatMessage: 'Название не верного формата',
  },
  {
    fieldName: 'legalInn',
    minLength: 10,
    maxLength: 12,
    canBeEmpty: false,
    format: validNumber,
    isEmptyMessage: 'Введите ИНН',
    toShortMessage: 'ИНН должен содержать 10 или 12 цифр',
    tooLongMessage: 'ИНН должен содержать 10 или 12 цифр',
    formatMessage: 'ИНН должен содержать только цифры',
  },
  {
    fieldName: 'legalEntityType',
    canBeEmpty: false, // можно не выбирать
    minLength: 1,
    maxLength: 1,
    format: validNumber,
    isEmptyMessage: 'Выберите организационно-правовую форму',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
]

export const clusterValidationsForm = [
  {
    fieldName: 'type',
    canBeEmpty: false, // можно не заполнять
    format: validNumber,
    isEmptyMessage: 'Выберите тип',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
  {
    fieldName: 'legalName',
    minLength: 3,
    maxLength: 255,
    canBeEmpty: false, // можно не заполнять
    format: validName,
    isEmptyMessage: 'Введите название организации',
    toShortMessage: 'Название слишком короткое',
    tooLongMessage: 'Название слишком длинное',
    formatMessage: 'Название не верного формата',
  },
  {
    fieldName: 'legalInn',
    minLength: 10,
    maxLength: 12,
    canBeEmpty: false, // можно не заполнять
    format: validNumber,
    isEmptyMessage: 'Введите ИНН',
    toShortMessage: 'ИНН должен содержать 10 или 12 цифр',
    tooLongMessage: 'ИНН должен содержать 10 или 12 цифр',
    formatMessage: 'ИНН должен содержать только цифры',
  },
  {
    fieldName: 'legalAddress',
    minLength: 0,
    maxLength: 255,
    canBeEmpty: true, // можно не заполнять
    format: validDescription,
    isEmptyMessage: 'Введите юридический адрес',
    toShortMessage: 'Адрес слишком короткий',
    tooLongMessage: 'Адрес слишком длинный',
    formatMessage: 'Неверный формат адреса',
  },
  {
    fieldName: 'legalEntityType',
    canBeEmpty: false, // можно не выбирать
    minLength: 0,
    maxLength: 1,
    format: validNumber,
    isEmptyMessage: 'Выберите организационно-правовую форму',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
  {
    fieldName: 'name',
    minLength: 5,
    maxLength: 50,
    canBeEmpty: false,
    format: validName,
    isEmptyMessage: 'Введите название',
    toShortMessage: 'Название слишком короткое',
    tooLongMessage: 'Название слишком длинное',
    formatMessage: 'Название не верного формата',
  },
  {
    fieldName: 'description',
    minLength: 20,
    maxLength: 1000,
    canBeEmpty: false,
    format: validDescription,
    isEmptyMessage: 'Введите описание',
    toShortMessage: 'Описание слишком коротокое',
    tooLongMessage: 'Описание слишком длинное',
    formatMessage: 'Описание не верного формата',
  },
  {
    fieldName: 'writeOff',
    minLength: 1,
    maxLength: 3,
    canBeEmpty: false,
    format: validPercent,
    isEmptyMessage: 'Введите % списания',
    toShortMessage: '% списания от 1 до 100',
    tooLongMessage: '% списания от 1 до 100',
    formatMessage: '% списания от 1 до 100',
  },
  {
    fieldName: 'phone_number',
    canBeEmpty: false,
    minLength: 5,
    maxLength: 12,
    format: validPhone,
    isEmptyMessage: 'Введите номер телефона',
    toShortMessage: 'Номер телефона слишком короткий',
    tooLongMessage: 'Номер телефона слишком длинный',
    formatMessage: 'Номер телефона не верного формата',
  },
]

export const categoryValidations = [
  {
    fieldName: 'name',
    minLength: 4,
    maxLength: 50,
    canBeEmpty: false,
    format: validName,
    isEmptyMessage: 'Введите название',
    toShortMessage: 'Название слишком короткое',
    tooLongMessage: 'Название слишком длинное',
    formatMessage: 'Название не верного формата',
  },
  {
    fieldName: 'sortOrder',
    minLength: 0,
    maxLength: 6,
    canBeEmpty: true,
    format: validNumber,
    isEmptyMessage: 'Введите число',
    toShortMessage: 'Значение слишком короткое',
    tooLongMessage: 'Значение слишком длинное',
    formatMessage: 'Значение не верного формата',
  },
  {
    fieldName: 'description',
    minLength: 20,
    maxLength: 500,
    canBeEmpty: false,
    format: validDescription,
    isEmptyMessage: 'Введите описание',
    toShortMessage: 'Описание слишком коротокое',
    tooLongMessage: 'Описание слишком длинное',
    formatMessage: 'Описание не верного формата',
  },
]

export const documentValidations = [
  {
    fieldName: 'name',
    minLength: 4,
    maxLength: 50,
    canBeEmpty: false,
    format: validName,
    isEmptyMessage: 'Введите название',
    toShortMessage: 'Название слишком короткое',
    tooLongMessage: 'Название слишком длинное',
    formatMessage: 'Название не верного формата',
  },
  {
    fieldName: 'description',
    minLength: 0,
    maxLength: 500,
    canBeEmpty: true,
    format: validDescription,
    isEmptyMessage: 'Введите описание',
    toShortMessage: 'Описание слишком короткое',
    tooLongMessage: 'Описание слишком длинное',
    formatMessage: 'Описание не верного формата',
  },
]
// В constants.ts

export const promoValidationsExtended: ValidationRulesInterface[] = [
  {
    fieldName: 'minSum',
    canBeEmpty: true,
    minLength: 0,
    maxLength: 10,
    format: /^$|^\d+$/,
    isEmptyMessage: 'Введите сумму порога',
    toShortMessage: '',
    tooLongMessage: 'Слишком большое значение',
    formatMessage: 'Введите число',
  },
  {
    fieldName: 'giftItemIds',
    canBeEmpty: false,
    minLength: 0,
    maxLength: 100,
    format: '',
    isEmptyMessage: 'Выберите хотя бы один товар-подарок',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
  {
    fieldName: 'name',
    canBeEmpty: false,
    minLength: 2,
    maxLength: 100,
    isEmptyMessage: 'Введите название промо акции',
    toShortMessage: 'Название слишком короткое (минимум 2 символа)',
    tooLongMessage: 'Название слишком длинное (максимум 100 символов)',
    formatMessage: '',
  },
  {
    fieldName: 'description',
    canBeEmpty: false,
    minLength: 10,
    maxLength: 500,
    isEmptyMessage: 'Введите описание промо акции',
    toShortMessage: 'Описание слишком короткое (минимум 10 символов)',
    tooLongMessage: 'Описание слишком длинное (максимум 500 символов)',
    formatMessage: '',
  },
  {
    fieldName: 'agreement',
    canBeEmpty: true,
    minLength: 0,
    maxLength: 100,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: 'Номер договора слишком длинный (максимум 100 символов)',
    formatMessage: '',
  },
  {
    fieldName: 'discount',
    canBeEmpty: true,
    format: /^$|^\d+$/,
    minLength: 0,
    maxLength: 3,
    isEmptyMessage: 'Введите размер скидки',
    toShortMessage: 'Значение слишком короткое',
    tooLongMessage: 'Скидка не может быть больше 100%',
    formatMessage: 'Введите число',
  },
  {
    fieldName: 'discountCode',
    canBeEmpty: true,
    minLength: 3,
    maxLength: 20,
    format: /^[a-zA-Z0-9_-]+$/,
    isEmptyMessage: 'Введите промокод',
    toShortMessage: 'Промокод слишком короткий (минимум 3 символа)',
    tooLongMessage: 'Промокод слишком длинный (максимум 20 символов)',
    formatMessage: 'Только латинские буквы, цифры, дефис и подчеркивание',
  },
  {
    fieldName: 'itemsFor',
    canBeEmpty: false,
    minLength: 0,
    maxLength: 100,
    format: '',
    isEmptyMessage: 'Выберите хотя бы один товар',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
  {
    fieldName: 'categoriesFor',
    canBeEmpty: false,
    minLength: 0,
    maxLength: 100,
    format: '',
    isEmptyMessage: 'Выберите хотя бы одну категорию',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
  {
    fieldName: 'storesFor',
    canBeEmpty: false,
    minLength: 0,
    maxLength: 100,
    format: '',
    isEmptyMessage: 'Выберите торговые точки',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
  {
    fieldName: 'sortOrder',
    minLength: 0,
    maxLength: 6,
    canBeEmpty: true,
    format: validNumber,
    isEmptyMessage: 'Введите число',
    toShortMessage: 'Значение слишком короткое',
    tooLongMessage: 'Значение слишком длинное',
    formatMessage: 'Значение не верного формата',
  },
]

// Дополнительно: бизнес-правила для проверки в useEffect
export const promoBusinessRules = {
  // Проверка скидки на диапазон 1-100%
  discountRange: {
    min: 1,
    max: 100,
    message: 'Скидка должна быть от 1 до 100%',
  },

  // Проверка дат (только если datesImportant = true)
  dateRules: {
    startBeforeEnd: 'Дата начала должна быть раньше даты окончания',
    notEqual: 'Дата начала и окончания не должны совпадать',
  },

  // Маппинг: какие поля становятся обязательными при каких toggles
  conditionalRequired: {
    discountCode: 'useDiscountCode',
    itemsFor: 'useItems',
    categoriesFor: 'useCategories',
  },
}

export const mapOptions = {
  zoomControl: false,
  streetViewControl: false,
  mapTypeControl: false,
  fullscreenControl: false,
  disableDefaultUI: true,
}

export const contactsPresets = [50, 100, 200, 300, 400, 500, 1000, 1500, 3000]

export const slotFilterPattern: ListParams = {
  cityId: '',
  sort: 'startTime',
  order: 'ASC',
  search: '',
  userId: '',
  status: '',
  transport_types: [],
  equipment_types: [],
  cargo_types: [],
  transport_side_types: [],
  transport_load_capacities: [],
}
export const transportFilterPattern: ListParams = {
  cityId: '',
  sort: 'startTime',
  order: 'ASC',
  search: '',
  userId: '',
  status: '',
  transport_types: [],
  equipment_types: [],
  cargo_types: [],
  transport_side_types: [],
  transport_load_capacities: [],
}
export const cargoFilterPattern: ListParams = {
  cityId: '',
  sort: 'startTime',
  order: 'ASC',
  search: '',
  userId: '',
  status: '',
  transport_types: [],
  equipment_types: [],
  cargo_types: [],
  transport_side_types: [],
  transport_load_capacities: [],
}

export const commonFilterPattern: ListParams = {
  cityId: '',
  sort: 'startTime',
  order: 'ASC',
  search: '',
  userId: '',
  status: '',
  transport_types: [],
  equipment_types: [],
  cargo_types: [],
  transport_side_types: [],
  transport_load_capacities: [],
}

export const orderStatusOptions = [
  {
    id: String(Status.NEW),
    name: orderStatusToText(Status.NEW),
    label: orderStatusToText(Status.NEW),
    value: String(Status.NEW),
  },
  {
    id: String(Status.POSTPONED),
    name: orderStatusToText(Status.POSTPONED),
    label: orderStatusToText(Status.POSTPONED),
    value: String(Status.POSTPONED),
  },
  {
    id: String(Status.CANCELED),
    name: orderStatusToText(Status.CANCELED),
    label: orderStatusToText(Status.CANCELED),
    value: String(Status.CANCELED),
  },
  {
    id: String(Status.COMPLETED),
    name: orderStatusToText(Status.COMPLETED),
    label: orderStatusToText(Status.COMPLETED),
    value: String(Status.COMPLETED),
  },
  {
    id: String(Status.DISRUPTED),
    name: orderStatusToText(Status.DISRUPTED),
    label: orderStatusToText(Status.DISRUPTED),
    value: String(Status.DISRUPTED),
  },
  {
    id: String(Status.ARCHIVED),
    name: orderStatusToText(Status.ARCHIVED),
    label: orderStatusToText(Status.ARCHIVED),
    value: String(Status.ARCHIVED),
  },
  {
    id: String(Status.IN_WORK),
    name: orderStatusToText(Status.IN_WORK),
    label: orderStatusToText(Status.IN_WORK),
    value: String(Status.IN_WORK),
  },
  // {
  //   id: String(Status.DELETED),
  //   name: orderStatusToText(Status.DELETED),
  //   label: orderStatusToText(Status.DELETED),
  //   value: String(Status.DELETED),
  // },
]

export const instructions: Instruction[] = [
  {
    id: 1,
    title: 'Авторизация и регистрация',
    description: `Мы используем для регистрации, авторизации и уведомлений Telegram бот. 
    После нажатия на кнопку «Перейти в бот», вы будете переадресованы в чат нашего бота, где нажмите «Старт» или введите «/login».
    Если вы ранее не были зарегистрированы, система предложит вам зарегистрироваться.
    Не удаляйте и не блокируйте бот, мы сообщим вам о важных событиях и входящих сообщениях через него.`,
    images: [auth_1, auth_2, auth_3],
  },
  {
    id: 2,
    title: 'Просмотр и поиск заказов',
    description: `Вы можете подбирать и просматривать слоты, грузы или транспорт в списках или на карте. На главной странице представлен общий список транспорта, слотов и грузов на карте, а также выборочно актуальные предложения по разделам.`,
    images: [orders_main, orders, orders_map],
  },
  {
    id: 3,
    title: 'На карте',
    description: `Поиск слотов, грузов или транспорта на карте позволит вам найти подходящий и перейти к карточке прямо с карты. 
    Точки с высокой концетрацией слотов, грузов или транспорта объединяются в кластеры, с указанием количества в кластере. Вы можете развернуть кластер по клику.`,
    images: [on_map_1, on_map_2, on_map_3],
  },
  {
    id: 4,
    title: 'Фильтры',
    description: `Для вашего удобства в резделах сервиса есть фильтры, которые позволяют отобрать слоты, грузы, транспорт по дате создания, городу, статусу или выполнить текстовый поиск по наименованию или описанию. 
      Настроенные фильтры сохраняются в вашем браузере. Настроив фильтры, вы будете получать обновления по разделам в соответствии с фильтрами.`,
    images: [filters, sort],
  },
  {
    id: 5,
    title: `Откликнуться на заказ`,
    description: `Для того чтобы сделать предложение заказчику или перевозчику, подберите подходящее предложение и кликните «Написать в чат».  `,
    images: [],
  },
  {
    id: 6,
    title: 'Чат',
    description: `В чате вы можете свободно вести общение по выбранному транспорту, слоту или грузу, даже когда он более не актуален. 
    Обратите внимание, чат может быть заархивирован собеседником или удален. В этом случае собеседник может не увидеть ваши сообщения. Всем участникам чата доступно архивирование и удаление тем. 
    При этом заархивированная или удаленная вами тема, остается доступной вашему собеседнику, пока он не выполнит те же действия.
     Обращаем ваше внимание вся информация, которую вы предоставляете в чат, является публичной, мы не несем ответственности за ее сохранность вашим собеседником.`,
    images: [],
  },
  {
    id: 13,
    title: 'Создание заказов',
    description: `Для создания перевозок, транспорта и слотов предназначены специальные формы разбитые на шаги. В настоящий момент вы можете указать:
    - Наименование,
    - Описание - просим вас указать максимум не персонализированных деталей вашего слота, груза или транспорта,
    - Предлагаемую или ожидаемую ставку - не обязательно,
    - Адрес для слота, адрес или просто город нахождения транспорта. Для транспорта и груза вы можете указать маршрут из нескольких точек с точностью до города или адреса,
    - Дата и время подачи для слотов и грузов,
    - Также мы просим вас загрузить как минимум одно и максимум 3 изображения с вашим грузом, транспортом или локацией, на ваше усмотрение.`,
    images: [create_order_1, create_order_2, create_order_3],
  },
  {
    id: 14,
    title: 'Типы транспорта, грузов и заполнение грузовых мест',
    description: `При создании слотов, грузов и транспорта, вы можете включить добавление типа транпорта, типа груза и заполнить грузовые места. 
    Рекомендуем вам заполнять максимум информации. Это поможет подобрать для вас оптимальные предложения. Не хватило настроек? Напишите в поддержку.
    Для вашего удобства мы сделали кнопки автозаполнения типовых размеров паллет.`,
    images: [types_1, types_2, types_3],
  },
  {
    id: 11,
    title: 'Работа с заказами',
    description: `При создании слота, груза или транспорта он автоматически получает статус новый и доступен для просмотра всем участникам сервиса. Вы можете отложить, отредактировать, отменить или завершить его в карточке заказа. 
      В чате по вашему слоту или грузу вы можете назначить собеседника исполнителем по кнопке в окне сообщений. После чего вы или исполнитель сможете заказ завершить.`,
    images: [],
  },
  {
    id: 12,
    title: 'Навигаторы',
    description: `Каждый слот, груз или транспорт содержит в карточке ссылки на самые распространенные навигаторы. 
    Для слота и транспорта без маршрута будет построен маршрут к точке подачи от вашего текущего местоположения. Для груза и транспорта с маршрутом будет проложен маршрут по всем точкам маршрута.`,
    images: [navi_icons, navi],
  },
  {
    id: 7,
    title: 'Поддержка',
    description:
      'Раздел поддержка в чате позволяет вам в любой момент связаться с нами. При необходимости мы можем запросить ваш контактный номер для решения сложных вопросов. В этом случае оператор свяжется с вами по телефону.',
    images: [support],
  },

  {
    id: 8,
    title: 'Оплата услуг',
    description: `Стоимость наших услуг 1 контакт = 1 рубль. При регистрации мы предоставляем вам 100 контактов для того, чтобы вы могли начать работать со "Слотами", "Грузами" и "Транспортом".
    При нажатии "написать в чат" в слоте, грузе или транспорте, мы проверим есть ли у вас доступный остаток контактов на балансе и не начат ли этот диалог ранее. Если диалог новый, то мы спишем 1 контакт, если контактов на балансе нет,
    мы предложим вам пополнить баланс в нашем сервисе. Вы можете пополнить баланс в любой момент в разделе "Настройки". Доступны все современные способы оплаты.
    `,
    images: [settings, payment, payment_method],
  },
  {
    id: 9,
    title: 'Репутация',
    description: `В ближайшее время в нашем сервисе станет доступен сервис проверки репутации контрагентов. О появлении в доступе мы сообщим вам дополнительно`,
    images: [],
  },
  {
    id: 10,
    title: 'Улучшения',
    description: `Мы постоянно развиваемся. Вы можете в скором времени рассчитывать на появление мобильного приложения для работы с заказами и многого другого. Мы также открыты для ваших предложений о сотрудничестве и улучшении сервиса. Воспользуйтесь разделом поддержка для ваших идей. Спасибо, что доверяете нашему сервису!`,
    images: [],
  },
]

export const transportTypes = [
  { id: TransportTypes.SCOOTER, name: 'Скутер', image: '' },
  { id: TransportTypes.CAR, name: 'Легковой', image: '' },
  { id: TransportTypes.COMBI_CAR, name: 'Комби', image: '' },
  { id: TransportTypes.MINIBUS, name: 'Микроавтобус', image: '' },
  { id: TransportTypes.TRUCK, name: 'Грузовой', image: '' },
]

export const transportLoadCapacities = [
  {
    id: TransportLoadCapacities.ZERO_POINT_FIVE,
    name: '0.5 тонны',
    image: '',
    referenceTransportType: [TransportTypes.MINIBUS, TransportTypes.COMBI_CAR],
  },
  {
    id: TransportLoadCapacities.ONE,
    name: '1 тонна',
    image: '',
    referenceTransportType: [TransportTypes.MINIBUS, TransportTypes.COMBI_CAR],
  },
  {
    id: TransportLoadCapacities.ONE_POINT_FIVE,
    name: '1.5 тонны',
    image: '',
    referenceTransportType: [TransportTypes.MINIBUS, TransportTypes.TRUCK],
  },
  {
    id: TransportLoadCapacities.THREE,
    name: '3 тонны',
    image: '',
    referenceTransportType: [TransportTypes.MINIBUS, TransportTypes.TRUCK],
  },
  {
    id: TransportLoadCapacities.FIVE,
    name: '5 тонн',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
  },
  {
    id: TransportLoadCapacities.TEN,
    name: '10 тонн',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
  },
  {
    id: TransportLoadCapacities.TWENTY,
    name: '20 тонн',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
  },
  {
    id: TransportLoadCapacities.TWENTY_FIVE,
    name: '25 тонн',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
  },
  {
    id: TransportLoadCapacities.THIRTY,
    name: '30 тонн',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
  },
  {
    id: TransportLoadCapacities.THIRTY_FIVE,
    name: '35 тонн',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
  },
  {
    id: TransportLoadCapacities.FORTY,
    name: '40 тонн',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
  },
]

export const transportSideTypes = [
  {
    id: TransportSideTypes.AWING,
    name: 'Тент',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
    referenceLoadCapacity: [
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
      TransportLoadCapacities.THIRTY_FIVE,
      TransportLoadCapacities.THIRTY,
      TransportLoadCapacities.FORTY,
      TransportLoadCapacities.TWENTY_FIVE,
    ],
  },
  {
    id: TransportSideTypes.DUMP_TRUCK,
    name: 'Самосвал',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
    referenceLoadCapacity: [
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
      TransportLoadCapacities.THIRTY_FIVE,
      TransportLoadCapacities.THIRTY,
      TransportLoadCapacities.FORTY,
      TransportLoadCapacities.TWENTY_FIVE,
    ],
  },
  {
    id: TransportSideTypes.GRAIN_CARRIER,
    name: 'Зерновоз',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
    referenceLoadCapacity: [
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
      TransportLoadCapacities.THIRTY_FIVE,
      TransportLoadCapacities.THIRTY,
      TransportLoadCapacities.FORTY,
      TransportLoadCapacities.TWENTY_FIVE,
    ],
  },
  {
    id: TransportSideTypes.MIXER,
    name: 'Бетоносмеситель',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
    referenceLoadCapacity: [
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
      TransportLoadCapacities.THIRTY_FIVE,
      TransportLoadCapacities.THIRTY,
      TransportLoadCapacities.FORTY,
      TransportLoadCapacities.TWENTY_FIVE,
    ],
  },
  {
    id: TransportSideTypes.HARD_TOP,
    name: 'Фургон',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
    referenceLoadCapacity: [
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
      TransportLoadCapacities.THIRTY_FIVE,
      TransportLoadCapacities.THIRTY,
      TransportLoadCapacities.FORTY,
      TransportLoadCapacities.TWENTY_FIVE,
    ],
  },
  {
    id: TransportSideTypes.OPEN_SIDE,
    name: 'Открытый борт',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
    referenceLoadCapacity: [
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
      TransportLoadCapacities.THIRTY_FIVE,
      TransportLoadCapacities.THIRTY,
      TransportLoadCapacities.FORTY,
      TransportLoadCapacities.TWENTY_FIVE,
    ],
  },
  {
    id: TransportSideTypes.REFRIGERATOR_MINUS,
    name: 'Рефрежиратор -7',
    image: '',
    referenceTransportType: [
      TransportTypes.TRUCK,
      TransportTypes.MINIBUS,
      TransportTypes.COMBI_CAR,
    ],
    referenceLoadCapacity: [
      TransportLoadCapacities.ZERO_POINT_FIVE,
      TransportLoadCapacities.ONE,
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
      TransportLoadCapacities.THIRTY_FIVE,
      TransportLoadCapacities.THIRTY,
      TransportLoadCapacities.FORTY,
    ],
  },
  {
    id: TransportSideTypes.REFRIGERATOR_PLUS,
    name: 'Рефрежиратор +7',
    image: '',
    referenceTransportType: [
      TransportTypes.TRUCK,
      TransportTypes.MINIBUS,
      TransportTypes.COMBI_CAR,
    ],
    referenceLoadCapacity: [
      TransportLoadCapacities.ZERO_POINT_FIVE,
      TransportLoadCapacities.ONE,
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
      TransportLoadCapacities.THIRTY_FIVE,
      TransportLoadCapacities.THIRTY,
      TransportLoadCapacities.FORTY,
    ],
  },
  {
    id: TransportSideTypes.TANK,
    name: 'Цисцерна',
    image: '',
    referenceTransportType: [
      TransportTypes.TRUCK,
      TransportTypes.MINIBUS,
      TransportTypes.COMBI_CAR,
    ],
    referenceLoadCapacity: [
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
      TransportLoadCapacities.THIRTY_FIVE,
      TransportLoadCapacities.THIRTY,
      TransportLoadCapacities.FORTY,
    ],
  },
  {
    id: TransportSideTypes.THERMO_VAN,
    name: 'Термофургон',
    image: '',
    referenceTransportType: [
      TransportTypes.TRUCK,
      TransportTypes.MINIBUS,
      TransportTypes.COMBI_CAR,
    ],
    referenceLoadCapacity: [
      TransportLoadCapacities.ZERO_POINT_FIVE,
      TransportLoadCapacities.ONE,
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
      TransportLoadCapacities.THIRTY_FIVE,
      TransportLoadCapacities.THIRTY,
      TransportLoadCapacities.FORTY,
    ],
  },
  {
    id: TransportSideTypes.TIMBER_TRUCK,
    name: 'Лесовоз',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
    referenceLoadCapacity: [
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
      TransportLoadCapacities.THIRTY_FIVE,
      TransportLoadCapacities.THIRTY,
      TransportLoadCapacities.FORTY,
    ],
  },
  {
    id: TransportSideTypes.TOW_TRUCK,
    name: 'Эвакуатор',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
    referenceLoadCapacity: [
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
      TransportLoadCapacities.THIRTY_FIVE,
      TransportLoadCapacities.THIRTY,
      TransportLoadCapacities.FORTY,
    ],
  },
  {
    id: TransportSideTypes.CAR_TRANSPORTER,
    name: 'Автовоз',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
    referenceLoadCapacity: [
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
      TransportLoadCapacities.THIRTY_FIVE,
      TransportLoadCapacities.THIRTY,
      TransportLoadCapacities.FORTY,
    ],
  },
]

export const equipmentTypes = [
  {
    id: EquipmentTypes.GLASS_STAND,
    name: 'Стойка для стекол',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
    referenceLoadCapacity: [
      TransportLoadCapacities.ZERO_POINT_FIVE,
      TransportLoadCapacities.ONE,
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
    ],
    referenceSideType: [
      TransportSideTypes.AWING,
      TransportSideTypes.HARD_TOP,
      TransportSideTypes.OPEN_SIDE,
    ],
  },
  {
    id: EquipmentTypes.HYDRAULIC_PLATFORM,
    name: 'Гидравлическая платформа',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
    referenceLoadCapacity: [
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
    ],
    referenceSideType: [
      TransportSideTypes.AWING,
      TransportSideTypes.HARD_TOP,
      TransportSideTypes.OPEN_SIDE,
      TransportSideTypes.REFRIGERATOR_MINUS,
      TransportSideTypes.REFRIGERATOR_PLUS,
      TransportSideTypes.THERMO_VAN,
    ],
  },
  {
    id: EquipmentTypes.MANIPULATOR,
    name: 'Манипулятор',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
    referenceLoadCapacity: [
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
    ],
    referenceSideType: [TransportSideTypes.OPEN_SIDE],
  },
  {
    id: EquipmentTypes.SIDE_LOADING,
    name: 'Боковая загрузка',
    image: '',
    referenceTransportType: [TransportTypes.TRUCK],
    referenceSideType: [
      TransportSideTypes.AWING,
      TransportSideTypes.HARD_TOP,
      TransportSideTypes.OPEN_SIDE,
      TransportSideTypes.REFRIGERATOR_MINUS,
      TransportSideTypes.REFRIGERATOR_PLUS,
      TransportSideTypes.THERMO_VAN,
    ],
    referenceLoadCapacity: [
      TransportLoadCapacities.ONE_POINT_FIVE,
      TransportLoadCapacities.THREE,
      TransportLoadCapacities.FIVE,
      TransportLoadCapacities.TEN,
      TransportLoadCapacities.TWENTY,
    ],
  },
  {
    id: EquipmentTypes.THERMO_BAG,
    name: 'Термосумка',
    image: '',
    referenceTransportType: [TransportTypes.CAR, TransportTypes.SCOOTER, TransportTypes.COMBI_CAR],
    referenceLoadCapacity: [],
    referenceSideType: [],
  },
]

export const cargoTypes: TypeSelectorItem[] = [
  {
    id: CargoTypes.CLOTHES,
    name: 'Одежда',
    image: '',
  },
  {
    id: CargoTypes.ELECTRONICS,
    name: 'Электроника',
    image: '',
  },
  {
    id: CargoTypes.FOOD,
    name: 'Продукты',
    image: '',
  },
  {
    id: CargoTypes.READY_FOOD,
    name: 'Готовая еда',
    image: '',
  },
  {
    id: CargoTypes.MIXED,
    name: 'Смешанный',
    image: '',
  },
  {
    id: CargoTypes.FRAGILE,
    name: 'Хрупкий',
    image: '',
  },
  {
    id: CargoTypes.LUMBER,
    name: 'Пиломатериалы',
    image: '',
  },
  {
    id: CargoTypes.ROLLED_METAL,
    name: 'Металлопрокат',
    image: '',
  },
  {
    id: CargoTypes.VEGETABLES_FRUITS,
    name: 'Овощи или фрукты',
    image: '',
  },
  {
    id: CargoTypes.BULK,
    name: 'Сыпучий груз',
    image: '',
  },
  {
    id: CargoTypes.GRAIN,
    name: 'Зерно',
    image: '',
  },
  {
    id: CargoTypes.WOOD,
    name: 'Лес кругляк',
    image: '',
  },
  {
    id: CargoTypes.BUILDING_MATERIALS,
    name: 'Стройматериалы',
    image: '',
  },
  {
    id: CargoTypes.SPARE_PARTS,
    name: 'Автозапчасти',
    image: '',
  },
]

export const schedulePattern = [
  { sequence: 1, from: '10:00', to: '19:00', dayOff: false },
  { sequence: 2, from: '10:00', to: '19:00', dayOff: false },
  { sequence: 3, from: '10:00', to: '19:00', dayOff: false },
  { sequence: 4, from: '10:00', to: '19:00', dayOff: false },
  { sequence: 5, from: '10:00', to: '19:00', dayOff: false },
  { sequence: 6, from: '10:00', to: '19:00', dayOff: false },
  { sequence: 7, from: '10:00', to: '19:00', dayOff: false },
]

export const ruleValidations: ValidationRulesInterface[] = [
  {
    fieldName: 'name',
    minLength: 3,
    maxLength: 100,
    canBeEmpty: false,
    format: /^.*$/, // любой текст
    isEmptyMessage: 'Введите название правила',
    toShortMessage: 'Минимум 3 символа',
    tooLongMessage: 'Максимум 100 символов',
    formatMessage: 'Название неверного формата',
  },
  {
    fieldName: 'action.value',
    minLength: 1,
    maxLength: 10,
    canBeEmpty: false,
    format: /^\d+(\.\d{1,2})?$/,
    isEmptyMessage: 'Введите значение действия',
    toShortMessage: 'Минимум 1 символ',
    tooLongMessage: 'Максимум 10 символов',
    formatMessage: 'Введите число (например: 10 или 10.5)',
  },
  {
    fieldName: 'priority',
    minLength: 1,
    maxLength: 3,
    canBeEmpty: true,
    format: /^[0-9]{0,3}$/,
    isEmptyMessage: 'Введите приоритет',
    toShortMessage: 'Минимум 1 цифра',
    tooLongMessage: 'Максимум 3 цифры',
    formatMessage: 'Приоритет от 0 до 999',
  },
]

export const stockDocumentValidations: ValidationRulesInterface[] = [
  {
    fieldName: 'number',
    canBeEmpty: false,
    minLength: 1,
    maxLength: 50,
    isEmptyMessage: 'Введите номер документа',
    toShortMessage: 'Номер документа слишком короткий',
    tooLongMessage: 'Номер документа слишком длинный (максимум 50 символов)',
    formatMessage: '',
  },
  {
    fieldName: 'storeId',
    canBeEmpty: false,
    minLength: 1,
    maxLength: 10,
    isEmptyMessage: 'Выберите магазин',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
  {
    fieldName: 'comment',
    canBeEmpty: true,
    minLength: 0,
    maxLength: 300,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: 'Комментарий слишком длинный (максимум 300 символов)',
    formatMessage: '',
  },
]

export const priceDocumentValidations: ValidationRulesInterface[] = [
  {
    fieldName: 'number',
    canBeEmpty: false,
    minLength: 1,
    maxLength: 50,
    isEmptyMessage: 'Введите номер документа',
    toShortMessage: 'Номер документа слишком короткий',
    tooLongMessage: 'Номер документа слишком длинный (максимум 50 символов)',
    formatMessage: '',
  },
  {
    fieldName: 'comment',
    canBeEmpty: true,
    minLength: 0,
    maxLength: 300,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: 'Комментарий слишком длинный (максимум 300 символов)',
    formatMessage: '',
  },
  // storeId удален — его нет в ценах
]

export const emailLoginFormValidations: ValidationRulesInterface[] = [
  {
    fieldName: 'email',
    minLength: 5,
    maxLength: 50,
    format: validEmail,
    canBeEmpty: false,
    isEmptyMessage: 'Введите email',
    toShortMessage: 'Email слишком короткий',
    tooLongMessage: 'Email слишком длинный',
    formatMessage:
      COUNTRY === 'ru' ? 'Некорректный email, используйте почту в зоне .ru' : 'Некорректный email',
  },
  {
    fieldName: 'code',
    minLength: 6,
    maxLength: 6,
    format: /^\d+$/,
    canBeEmpty: false,
    isEmptyMessage: 'Введите код',
    toShortMessage: 'Код должен содержать 6 цифр',
    tooLongMessage: 'Код должен содержать 6 цифр',
    formatMessage: 'Код должен содержать только цифры',
  },
]

export const BANNER_VARIANT_CONFIG: BannerVariantConfigMap = {
  [BannerVariant.BASE]: {
    hasCarousel: true,
    aspectRatio: { mobile: 'auto', desktop: 'auto' }, // auto для ширины
    contentAlign: 'center',
    overlay: true,
  },
  [BannerVariant.SPLIT]: {
    hasCarousel: false,
    aspectRatio: { mobile: 1 / 1, desktop: 16 / 9 },
    contentAlign: 'left',
    overlay: false,
  },
  [BannerVariant.EXPANDED]: {
    hasCarousel: true,
    aspectRatio: { mobile: 'auto', desktop: 'auto' }, // тоже auto
    contentAlign: 'center',
    overlay: true,
  },
  [BannerVariant.COMPACT]: {
    hasCarousel: false,
    aspectRatio: { mobile: 16 / 9, desktop: 16 / 9 },
    contentAlign: 'center',
    overlay: true,
  },
  [BannerVariant.HERO]: {
    hasCarousel: true,
    aspectRatio: { mobile: 9 / 16, desktop: 21 / 9 },
    contentAlign: 'center',
    overlay: true,
  },
}

export const leadValidations: ValidationRulesInterface[] = [
  {
    fieldName: 'phone',
    minLength: 11,
    maxLength: 20,
    canBeEmpty: false,
    format: validPhone,
    isEmptyMessage: 'Введите номер телефона',
    toShortMessage: 'Номер слишком короткий',
    tooLongMessage: 'Номер слишком длинный',
    formatMessage: 'Некорректный номер телефона',
  },
  {
    fieldName: 'question',
    minLength: 0,
    maxLength: 500,
    canBeEmpty: true,
    format: /./,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: 'Вопрос слишком длинный (максимум 500 символов)',
    formatMessage: '',
  },
]

// ========== PLACE VALIDATIONS ==========
export const placeValidations: ValidationRulesInterface[] = [
  {
    fieldName: 'storeId',
    canBeEmpty: false,
    minLength: 1,
    format: validNumber,
    isEmptyMessage: 'Выберите торговую точку',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
  {
    fieldName: 'name',
    canBeEmpty: false,
    minLength: 4,
    maxLength: 50,
    format: validName,
    isEmptyMessage: 'Введите название места',
    toShortMessage: 'Название слишком короткое (минимум 4 символа)',
    tooLongMessage: 'Название слишком длинное (максимум 50 символов)',
    formatMessage: 'Название содержит недопустимые символы',
  },
  {
    fieldName: 'description',
    minLength: 30,
    maxLength: 500,
    canBeEmpty: false,
    format: validDescription,
    isEmptyMessage: 'Введите описание места',
    toShortMessage: 'Название слишком короткое (минимум 30 символов)',
    tooLongMessage: 'Описание слишком длинное (максимум 500 символов)',
    formatMessage: 'Описание содержит недопустимые символы',
  },
  {
    fieldName: 'placeNumber',
    minLength: 0,
    maxLength: 50,
    canBeEmpty: true,
    format: validName,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: 'Номер места слишком длинный (максимум 50 символов)',
    formatMessage: 'Номер места содержит недопустимые символы',
  },
  {
    fieldName: 'sortOrder',
    minLength: 0,
    maxLength: 6,
    canBeEmpty: true,
    format: validNumber,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: 'Слишком большое число',
    formatMessage: 'Введите число',
  },
  {
    fieldName: 'slotDurationMinutes',
    minLength: 0,
    maxLength: 5,
    canBeEmpty: true,
    format: validNumber,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: 'Слишком большое значение',
    formatMessage: 'Введите число',
  },
  {
    fieldName: 'slotIntervalMinutes',
    minLength: 0,
    maxLength: 5,
    canBeEmpty: true,
    format: validNumber,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: 'Слишком большое значение',
    formatMessage: 'Введите число',
  },
  {
    fieldName: 'breakBetweenSlotsMinutes',
    minLength: 0,
    maxLength: 5,
    canBeEmpty: true,
    format: validNumber,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: 'Слишком большое значение',
    formatMessage: 'Введите число',
  },
  {
    fieldName: 'minBookingDurationMinutes',
    minLength: 0,
    maxLength: 5,
    canBeEmpty: true,
    format: validNumber,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: 'Слишком большое значение',
    formatMessage: 'Введите число',
  },
  {
    fieldName: 'maxBookingDurationMinutes',
    minLength: 0,
    maxLength: 6,
    canBeEmpty: true,
    format: validNumber,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: 'Слишком большое значение',
    formatMessage: 'Введите число',
  },
  {
    fieldName: 'cancellationDeadlineMinutes',
    minLength: 0,
    maxLength: 5,
    canBeEmpty: true,
    format: validNumber,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: 'Слишком большое значение',
    formatMessage: 'Введите число',
  },
  {
    fieldName: 'checkinTime',
    minLength: 0,
    maxLength: 5,
    canBeEmpty: true,
    format: /^$|^([01]\d|2[0-3]):([0-5]\d)$/,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: 'Введите время в формате ЧЧ:ММ',
  },
  {
    fieldName: 'checkoutTime',
    minLength: 0,
    maxLength: 5,
    canBeEmpty: true,
    format: /^$|^([01]\d|2[0-3]):([0-5]\d)$/,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: 'Введите время в формате ЧЧ:ММ',
  },
]

export const motivationValidations: ValidationRulesInterface[] = [
  {
    fieldName: 'name',
    canBeEmpty: false,
    minLength: 4,
    maxLength: 50,
    format: validName,
    isEmptyMessage: 'Введите название мотивации',
    toShortMessage: 'Название слишком короткое (минимум 4 символа)',
    tooLongMessage: 'Название слишком длинное (максимум 50 символов)',
    formatMessage: 'Название содержит недопустимые символы',
  },
  {
    fieldName: 'description',
    minLength: 30,
    maxLength: 500,
    canBeEmpty: false,
    format: validDescription,
    isEmptyMessage: 'Введите описание мотивации',
    toShortMessage: 'Название слишком короткое (минимум 30 символов)',
    tooLongMessage: 'Описание слишком длинное (максимум 500 символов)',
    formatMessage: 'Описание содержит недопустимые символы',
  },
]

export const executorValidations: ValidationRulesInterface[] = [
  {
    fieldName: 'name',
    canBeEmpty: false,
    minLength: 2,
    maxLength: 100,
    format: validName,
    isEmptyMessage: 'Введите имя исполнителя',
    toShortMessage: 'Имя слишком короткое',
    tooLongMessage: 'Имя слишком длинное',
    formatMessage: '',
  },
  {
    fieldName: 'phone_number',
    canBeEmpty: false,
    minLength: 5,
    maxLength: 20,
    format: validPhone,
    isEmptyMessage: 'Введите телефон',
    toShortMessage: 'Телефон слишком короткий',
    tooLongMessage: 'Телефон слишком длинный',
    formatMessage: '',
  },
  {
    fieldName: 'motivationId',
    canBeEmpty: false,
    minLength: 1,
    isEmptyMessage: 'Выберите мотивацию',
    toShortMessage: '',
    tooLongMessage: '',
    formatMessage: '',
  },
]

export const complexOrderValidations: ValidationRulesInterface[] = [
  {
    fieldName: 'phone_number',
    canBeEmpty: false,
    minLength: 5,
    maxLength: 15,
    format: validPhone,
    isEmptyMessage: 'Введите номер телефона',
    toShortMessage: 'Номер телефона слишком короткий',
    tooLongMessage: 'Номер телефона слишком длинный',
    formatMessage: 'Номер телефона не верного формата',
  },
  {
    fieldName: 'customerName',
    minLength: 0,
    maxLength: 50,
    canBeEmpty: true,
    format: validDescription,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: 'Имя слишком длинное',
    formatMessage: 'Имя не верного формата',
  },
  {
    fieldName: 'notes',
    minLength: 0,
    maxLength: 500,
    canBeEmpty: true,
    format: validDescription,
    isEmptyMessage: '',
    toShortMessage: '',
    tooLongMessage: 'Заметки слишком длинные',
    formatMessage: 'Заметки не верного формата',
  },
]
